<template>
  <div>
    <right-panel :datas="connects" @onClose="onCloseForm" ref="right-panel-add">
      <div slot="header">
        <translate>Add Instance</translate>
      </div>
      <div slot="content" class="wrapper-padding">
        <el-form :model="addForm" :rules="rules" ref="addForm" label-width="120px" class="add-form">
          <el-form-item :label="attrText.resourceName" prop="name">
            <el-input v-model.trim="addForm.name" :placeholder="attrText.resourceName"></el-input>
          </el-form-item>
          <!--<el-form-item :label="attrText.instanceId" prop="instanceId">-->
            <!--<el-input v-model="addForm.instanceId" :placeholder="attrText.instanceId"></el-input>-->
          <!--</el-form-item>-->
          <el-form-item :label="attrText.ipAddress" prop="ipAddress">
            <el-input v-model="addForm.ipAddress" placeholder="IP"></el-input>
          </el-form-item>
          <el-form-item :label="attrText.os" prop="os">
            <el-select v-model="addForm.os" @change="selectDefault">
              <el-option label="Windows" value="win32"></el-option>
              <el-option label="Linux" value="linux"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="attrText.username" prop="username">
            <el-input v-model="addForm.username"></el-input>
            <translate>Multiple users with semicolons ‘;’</translate>
          </el-form-item>
          <el-form-item :label="attrText.port" prop="port">
            <el-input v-model="addForm.port"></el-input>
          </el-form-item>
          <el-form-item :label="attrText.flavor" prop="flavor">
            <el-input type="textarea" v-model="addForm.flavor" :placeholder="attrText.defaultFlavorText"></el-input>
          </el-form-item>
          <el-form-item :label="attrText.clipboard" v-if="addForm.os === 'win32'">
						<el-switch style="margin-right: 16px" v-model="addForm.clipboard" on-text="" off-text=""></el-switch>
					</el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" :disabled="btnDisabled" @click="onSubmitAddForm()" :loading="loading">
          <translate>Save</translate>
        </el-button>
        <el-button @click="onCloseForm()">
          <translate>Cancel</translate>
        </el-button>
      </div>
    </right-panel>
  </div>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'ClusterAddInstance',
    props: {
      items: {
        required: true
      }
    },
    data () {
      var validEmpty = (rule, value, callback) => {
        if (value.trim() === '') {
          callback(new Error(this.$gettext('Please input the username')))
        } else {
          callback()
        }
      }
      return {
        connects: null,
        loading: false,
        addForm: {
          name: '',
          instanceId: '',
          ipAddress: '',
          os: 'linux',
          username: 'root',
          port: '22',
          flavor: '',
          clipboard: true,
        },
        btnDisabled: false,
        rules: {
          name: [
            {required: true, message: this.$gettext('Please input the resource name'), trigger: 'change'}
          ],
          instanceId: [
            {message: this.$gettext('Please input the instance_id'), trigger: 'change'}
          ],
          ipAddress: [
            {required: true, message: this.$gettext('Please input the Inner IP'), trigger: 'change'},
            {
              pattern: /^(\d{1,3}|\*)(\.(\d{1,3}|\*)){3}$/,
              message: this.$gettext('please input the right Inner IP'),
              trigger: 'change'
            }
          ],
          os: [
            {required: true, message: this.$gettext('Please input the userName'), trigger: 'change'}
          ],
          username: [
            {required: true, message: this.$gettext('Please input the username'), trigger: 'change'},
            {validator: validEmpty, trigger: 'change'}
          ],
          port: [
            {required: true, message: this.$gettext('Please input the port'), trigger: 'change'},
            {
              pattern: /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
              message: this.$gettext('please input the right port'),
              trigger: 'change'
            }
          ],
          flavor: [
            {
              message: this.$gettext('Please input the flavor descroption'),
              trigger: 'change'
            }
          ]
        }
      }
    },
    computed: {
      attrText () {
        return this.getTransitionText()
      }
    },
    methods: {
      getTransitionText () {
        return {
          resourceName: this.$gettext('Resource name'),
          instanceId: this.$gettext('Instance ID'),
          defaultIdText: this.$gettext('Confirm that agent has integrated AK'),
          ipAddress: this.$gettext('Inner IP'),
          os: this.$gettext('OS'),
          username: this.$gettext('Username'),
          port: this.$gettext('Port'),
          flavor: this.$gettext('Flavor Descroption'),
          defaultFlavorText: this.$gettext('1 core 1G etc.'),
				  clipboard: this.$gettext('Clipboard'),
        }
      },
      selectDefault (val) {
        console.log(val)
        if (val === 'win32') {
          this.addForm.username = 'administrator'
          this.addForm.port = '3389'
        } else {
          this.addForm.username = 'root'
          this.addForm.port = '22'
        }
      },
      // 确定添加资源
      onSubmitAddForm () {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            this.loading = false
            let options = this.addForm
            let params = {
              data: {
                network_id: Number(this.$route.params.id),
                resources: [{
                  name: options.name,
                  ip_address: options.ipAddress,
                  os: options.os,
                  username: [],
                  port: Number(options.port),
                  flavor: options.flavor,
						      allow_copy_paste: this.addForm.clipboard,
                }]
              }
            }
            options.username.split(';').forEach(el => {
              if (el && el.trim()) {
                params.data.resources[0].username.push(el.trim())
              }
            })
            this.btnDisabled = true
            this.$store.dispatch(STORE_CONST.CLUSTER.ADD_RESOURCE, params).then(res => {
              this.btnDisabled = false
              this.loading = false
              this.$notify({
                message: this.$gettext('Add Successfully!'),
                type: 'success'
              })
              this.$emit('callback')
              this.$refs['right-panel-add'].onClose()
            }).catch(err => {
              this.btnDisabled = false
              this.loading = false
              if (err.code === 'ResourceExceeded') {
                this.$notify({
                  type: 'error',
                  message: this.$gettext('ResourceExceeded.')
                })
              }
            })
          }
        })
      },
      // 关闭添加成员
      onCloseForm () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
.add-form {
  .el-textarea__inner{
    height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// cluster-add-instance.vue?da0975b2